// src/pages/admin/Certificates/CertificatesManage.js
import React from 'react';
import { Card, List, Typography } from 'antd';

const { Text } = Typography;

const CertificatesManage = ({ certificates, users, courses = [] }) => (
  <Card title="Recent Certificates" bordered={false}>
    <List
      dataSource={certificates.slice(0, 5)} // Show top 5 recent certificates
      renderItem={(item) => {
        const userName = users.find((u) => u.id === item.user_id)?.name || 'Unknown';
        const courseTitle = courses.find((c) => c.id === item.course_id)?.title || 'No Course';
        const issuedDate = new Date(item.issued_at).toLocaleDateString(); // Format timestamp
        const expiresDate = item.expires_at ? new Date(item.expires_at).toLocaleDateString() : 'N/A';

        return (
          <List.Item>
            <Text>
              {`Code: ${item.certificate_code} - ${courseTitle} - Issued to ${userName} on ${issuedDate}`}
              {item.expires_at && ` (Expires: ${expiresDate})`}
            </Text>
          </List.Item>
        );
      }}
    />
  </Card>
);

export default CertificatesManage; // Corrected export name